module.exports = __webpack_public_path__ + "resources/img/img_datahunt5_m.823eab54a1700c6652d3cfb15b61dfbd.png";